// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"348":"1b81dfff78e3e7741b76","368":"76b039947d9465823168","954":"85da3399a71ff87d2a5f","988":"75e851a7b6316ebe61ff"}[chunkId] + ".js";
};